import { render, staticRenderFns } from "./product_carousel.html?vue&type=template&id=7eea406e&scoped=true&"
import script from "./product_carousel.ts?vue&type=script&lang=js&"
export * from "./product_carousel.ts?vue&type=script&lang=js&"
import style0 from "./product_carousel.scss?vue&type=style&index=0&id=7eea406e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eea406e",
  null
  
)

export default component.exports